<template>
  <div v-loading="page_init" :class="{ window }">
    <div style="font-size: 14px;color: #606266;">
      {{ $t('lang.FastAccess.deviceSn') }}：{{ window_dsn }}
    </div>
    <el-form :inline="true" :model="connectInfo" ref="connectInfo" :rules="rules">
      <el-form-item :label="$t('lang.Monitor.deviceAddress')" prop="hostname">
        <el-input disabled size="mini" v-model="connectInfo.hostname" class="webinput"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.terminalList.Port')">
        <el-input size="mini" v-model="connectInfo.port" class="webinput"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.openvpn.username')" prop="ssh_username">
        <el-input size="mini" name="ssh_name" autocomplete="off" :disabled="page_init"
          v-model="connectInfo.ssh_username" class="webinput"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.openvpn.password')" prop="ssH_password">
        <el-input v-model="connectInfo.ssH_password" autocomplete="off" :disabled="page_init" type="password"
          size="mini" class="webinput"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.webssh.SelectRoute')" prop="ssH_password">
        <el-select v-model="connectInfo.networkLine" size="mini">
          <el-option :label="$t('lang.webssh.DEFAULT')" value="DEFAULT"></el-option>
          <el-option :label="$t('lang.ConfigSetting.ChinaMobile')" value="CHINA_MOBILE"></el-option>
          <el-option :label="$t('lang.ConfigSetting.ChinaTelecom')" value="CHINA_TELECOM"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" :disabled="(url ? true : false) || ubconnectWait" type="primary" @click="connect">{{
          $t('lang.webssh.connect') }}</el-button>
        <el-button size="mini" type="primary" @click="openWindow" v-if="!window">{{ $t('lang.webssh.newWindwo')
        }}</el-button>
        <el-button size="mini" :disabled="(!url)" type="danger" @click="unconnect">{{ $t('lang.webssh.disconnect')
          }}</el-button>
      </el-form-item>
    </el-form>
    <div v-loading="loading" :element-loading-text="loadingText" :class="window ? 'iframe_box_window' : 'iframe_box'">
      <iframe v-if="url" :src="url" frameborder="0"></iframe>
      <p v-else>{{ $t('lang.smartsms.notConnect') }}</p>
    </div>
  </div>
</template>

<script>
import { getWebsshUrl, removeDeviceIp, heartBeat, pingIp, logError } from "@/api/particulars";
import { getDeviceMqttStatus } from "@/api/configurationlist";
export default {
  name: "webssh",
  props: ['did', 'dsn'],
  data() {
    return {
      loading: false,
      url: undefined,
      connectInfo: {
        hostname: '',
        port: 402,
        ssh_username: '',
        ssH_password: '',
        networkLine: 'DEFAULT'
      },
      page_init: true,
      current: '',
      rules: {
        ssh_username: { required: true, message: '请输入用户名', trigger: 'change' },
        ssH_password: { required: true, message: '请输入密码', trigger: 'change' }
      },
      timer: null,
      count: 0,
      pingStatus: false,
      hbTimer: null,
      ubconnectWait: false,
      window: false,
      window_did: undefined,
      window_dsn: undefined,
      loadingText: '',
    };
  },
  beforeDestroy() {
    if (this.window) {
      window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
    } else {
      if (this.connectInfo.hostname !== '') {
        this.unconnect()
      }
    }
  },
  methods: {
    getIp() {
      return new Promise((resolve, reject) => {
        getWebsshUrl({
          deviceSN: this.window_dsn,
          did: this.window_did,
          networkLine:this.connectInfo.networkLine
        }).then(res => {
          if (res.data.code == 0) {
            this.connectInfo.hostname = res.data.data
          } else {
            this.$message.error(res.data.error_message)
          }
          resolve()
        }).catch(err => { reject() })
      })
    },
    connect() {
      if (this.loading) return
      this.$refs.connectInfo.validate(async (res) => {
        if (res) {
          this.loadingText = this.$t('lang.webssh.tunnel')
          this.loading = true
          try {
            const res = await getDeviceMqttStatus(this.window_dsn)
            if (!res.data.online) {
              this.$message.error(this.$t('lang.webssh.DeviceMQTToffline'));
              this.loading = false;
              return
            }
          } catch (e) {
            this.$message.error(this.$t('lang.webssh.DeviceMQTToffline'));
            this.loading = false;
            return
          }
          try {
            await this.getIp()
          } catch (e) {
            this.$message.error(this.$t('lang.webssh.Failedtoobtainterminaladdress'))
            return
          }
          if (this.timer) {
            clearInterval(this.timer)
          } else {
            this.timer = setInterval(() => {
              if (!this.pingStatus) {
                this.pingStatus = true;
                pingIp({
                  deviceSN: this.window_dsn,
                  did: this.window_did,
                  ip: this.connectInfo.hostname
                }).then(res => {
                  console.log(this.count);
                  if (res.data.code === 0) {
                    clearInterval(this.timer);
                    this.timer = null;
                    setTimeout(() => {
                      this.url = location.origin + `/webssh/?hostname=${this.connectInfo.hostname}&username=${this.connectInfo.ssh_username}&password=${btoa(this.connectInfo.ssH_password)}&port=${this.connectInfo.port}`
                      // this.url = "https://singleyun.com" + `/webssh/?hostname=${this.connectInfo.hostname}&username=${this.connectInfo.ssh_username}&password=${btoa(this.connectInfo.ssH_password)}&port=${this.connectInfo.port}`
                      this.loading = false
                      this.hbApi()
                      this.heart()
                    }, (this.count === 0) ? 6000 : 3000);
                    this.count = 0;
                  }
                }).finally(async () => {
                  this.count++;
                  this.pingStatus = false;
                  if (this.count > 3) {
                    await logError({
                      deviceSN: this.window_dsn,
                      did: this.window_did,
                      ip: this.connectInfo.hostname,
                    })
                    clearInterval(this.timer)
                    this.timer = null;
                    this.$message.error(this.$t('lang.webssh.tunnelErr'))
                    this.loading = false
                    this.count = 0
                  }
                })
              }
            }, 3000);
          }
        }
      })
    },
    async unconnect(e) {
      if (this.connectInfo.hostname !== '') {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null;
        }
        this.loadingText = this.$t('lang.webssh.disconnectLoading')
        try {
          this.loading = true
          await this.disconnectHandler();
          this.ubconnectWait = true;
          setTimeout(() => {
            this.ubconnectWait = false
          }, 5000);
          if (this.hbTimer !== null) {
            clearInterval(this.hbTimer);
            this.hbTimer = null;
          }
          this.url = undefined;
          this.loading = false
        } catch {
          this.$message({
            showClose: true,
            message: this.$t('lang.devicelist.disbad'),
            type: "error"
          });
        }
      }
    },
    heart() {
      if (this.hbTimer) {
        clearInterval(this.hbTimer)
        this.hbTimer = null
      } else {
        this.hbTimer = setInterval(() => {
          this.hbApi()
        }, 60000);
      }
    },
    hbApi() {
      heartBeat({
        deviceSN: this.window_dsn,
        did: this.window_did,
        ip: this.connectInfo.hostname
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.warning(this.$t('lang.webssh.Unexpecteddisconnection'));
          this.unconnect()
        }
      }).catch(res => {
        this.$message.warning(this.$t('lang.webssh.Unexpecteddisconnection'));
        this.unconnect()
      })
    },
    async disconnectHandler() {
      let ip = this.connectInfo.hostname;
      this.connectInfo.hostname = ''
      try {
        const res = await removeDeviceIp({
          ip,
          deviceSN: this.window_dsn,
          did: this.window_did
        })
        if (res.status !== 200) {
          this.$message.error(res.data.message)
        }
      } finally {
        this.url = undefined;
      }
    },
    openWindow() {
      let { href } = this.$router.resolve({
        path: `/terminal/webssh/${this.window_did}/${this.window_dsn}`
      });
      window.open(href, "_blank");
    },
    beforeunloadFn(e) {
      e = e || window.event;
      if (e) {
        let ip = this.connectInfo.hostname;
        if (ip !== '') {
          removeDeviceIp({
            ip,
            deviceSN: this.window_dsn,
            did: this.window_did
          })
          if (this.hbTimer !== null) {
            clearInterval(this.hbTimer);
            this.hbTimer = null;
          }
        }
        e.returnValue = this.$t('lang.gateone.closeTips');
      }
      return this.$t('lang.gateone.closeTips');
    },
  },
  watch: {
    dsn: {
      immediate: true,
      handler() {
        if ((this.current != '') && (this.current != this.did)) {
          this.unconnect();
        } else if (this.current === '') {
          this.current = this.did
        }
      }
    },
  },
  mounted() {
    this.loadingText = this.$t('lang.webssh.tunnel')
    if (this.$route.name === 'Webssh') {
      this.window = true
      let { id, sn } = this.$route.params;
      this.window_did = id;
      this.window_dsn = sn;
      window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
    } else {
      this.window_did = this.did;
      this.window_dsn = this.dsn;
    }
    setTimeout(() => {
      this.page_init = false
    }, 500)
  },
};
</script>
<style scoped>
.iframe_box {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);
}

.iframe_box>iframe {
  width: 100%;
  height: 100%;
}

.iframe_box p {
  text-align: center;

}

.webinput {
  width: 120px;
}

.window {
  display: flex;
  flex-direction: column;
  margin: 20px;
  height: calc(100vh - 40px);
}


.iframe_box_window {
  height: 100%;
}

.iframe_box_window>iframe {
  width: 100%;
  height: 100%;
}
</style>